<template>
  <div id="app">
    <img
      class="c-background"
      :class="{ 'c-background--indented': visualIndented }"
      src="@/assets/images/background.jpg"
      srcset="@/assets/images/background.jpg 876w, @/assets/images/background@2x.jpg 1752w"
      alt="Future Forward"
    >
    <a href="http://www.futureforward.be/" class="c-logo" target="_blank">
      <img src="@/assets/images/logo.svg" alt="Future Forward">
    </a>
    <div class="c-main" :class="{ 'c-main--small': !visualIndented }">
      <div class="c-main__wrapper">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    visualIndented () {
      return this.$store.state.visualIndented
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/reset.css';
@import './assets/styles/variables.scss';

html,
body {
  height: 100%;
  overflow: hidden;
  position: fixed;
  width: 100%;
}

html {
  font-size: 62.5%;
}

body {
  background-color: $black;
  box-sizing: border-box;
  color: rgba(#FFF, 0.9);
  font: 1.6rem/2.4rem 'europa', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

body *,
body *:before,
body *:after {
  box-sizing: inherit;
}

@keyframes background {
  0% {
    opacity: 0;
    transform: translate(-5.6rem);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}

.c-background {
  animation: 1s $ease-out 0.2s 1 backwards background;
  height: 100%;
  left: -3.2rem;
  position: absolute;
  top: 0;
  transform: translateX(0);
  transition: transform 0.5s ease-in-out;
  width: auto;
}

.c-background--indented {
  transform: translateX(-20rem);
}

@keyframes logo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.c-logo {
  animation: 1s $ease-out 0.2s 1 both logo;
  bottom: 4rem;
  left: 4rem;
  outline: 0;
  position: absolute;
  width: 20rem;
  will-change: transform;

  &:before {
    content: '';
    background-image: linear-gradient(to top right, $black 0%, rgba($black, 0) 50%, rgba($black, 0) 100%);
    bottom: -4rem;
    height: 56rem;
    left: -4rem;
    pointer-events: none;
    position: absolute;
    width: 56rem;
    z-index: -1;
  }
}

.c-main {
  background: linear-gradient(to right, rgba($black, 0), rgba($black, 0.5) 5%, $black 20%);
  bottom: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 70vw;
  -webkit-overflow-scrolling: touch;
}

.c-main__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  margin: 0 auto;
  max-width: 100%;
  padding: 5.6rem 7.2rem;
  width: 82.4rem;
}

.c-main--small {
  width: 50vw;
}

.c-main a {
  color: $blue-light;
  text-decoration: none;

  &:hover {
    color: #FFF;
  }
}

.c-main p {
  display: block;
  margin-bottom: 1.6rem;
}

strong {
  color: #FFF;
  font-weight: 600;
}

.c-heading-1 {
  color: #FFF;
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 4rem;
  margin-bottom: 3.2rem;
}

.c-heading-1:not(:first-child) {
  margin-top: 2.4rem;
}

.c-heading-2 {
  color: #FFF;
  font-weight: 600;
  margin-bottom: 1.6rem;
  text-transform: uppercase;
}

.c-heading-1:not(:first-child) {
  margin-top: 2.4rem;
}

.c-list {
  list-style-type: disc;
  margin: 2rem 0;
  padding-left: 2rem;
}

.c-toolbar {
  display: flex;
  margin-top: 3.2rem;
}

.c-toolbar--split {
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.c-toolbar--split > * {
  flex: none;
  min-width: 30rem;
  width: calc(50% - 1.5rem);
}

.c-toolbar__right {
  margin-left: auto;
}

.c-progress-header {
  margin-bottom: 3rem;
  margin-top: -3rem;
}

.c-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(#FFF, 0.7);
  font-size: 1.3rem;
  line-height: 2rem;
  margin-top: 4rem;
  padding-top: 3.2rem;

  p {
    margin-bottom: 0.8rem;
  }
}

.c-logo-footer {
  margin-bottom: 1.6rem;
}

@media (max-width: $bp-medium) {
  .c-background {
    left: 50%;
    transform: translateX(-50%);
  }

  .c-background--indented {
    transform: translateX(-50%);
  }

  .c-logo {
    display: none;
  }

  .c-main {
    background: rgba($black, 0.85);
    left: 0;
    width: 100vw;
  }

  .c-main--small {
    width: 100vw;
  }

  .c-toolbar {
    display: block;

    & > * + * {
      margin-top: 0.8rem;
    }
  }
}

@media (max-width: $bp-small) {
  .c-main__wrapper {
    padding: 2.4rem;
  }

  .c-heading-1 {
    margin-bottom: 3.2rem;
  }

  .c-heading-1:not(:first-child) {
    margin-top: 0.8rem;
  }
}
</style>
